import React from "react";
import FormInput from "../UI/FormInput";
import { EMPLOYEE_THEME } from "./employeeTheme";

/**
 * Admin-only Pay Rate + Notes for employee add/update (not shown on My Profile).
 */
const EmployeePersonalExtraFields = ({ register, errors, canView = false }) => {
  if (!canView) return null;

  return (
    <>
      <FormInput
        label="Pay Rate"
        name="payRate"
        register={register}
        error={errors.payRate}
        placeholder="$40 per hour"
      />
      <div className="md:col-span-2 lg:col-span-3 space-y-1">
        <label
          htmlFor="personalNotes"
          className="block text-sm font-medium text-slate-700"
        >
          Notes
        </label>
        <textarea
          id="personalNotes"
          {...register("personalNotes")}
          rows={2}
          maxLength={2000}
          placeholder="Optional admin notes about this employee…"
          className={`block w-full rounded-md border border-slate-300 bg-white text-slate-900 text-sm py-1.5 px-2.5 outline-none transition-colors resize-y min-h-[2.75rem] ${EMPLOYEE_THEME.fieldFocus}`}
        />
        {errors.personalNotes ? (
          <p className="text-xs text-red-600">{errors.personalNotes.message}</p>
        ) : null}
      </div>
    </>
  );
};

export default EmployeePersonalExtraFields;
